export default {
    name: "name-and-mobile-number-form",
    emits: ["canContinue"],
    data() {
        return {
            firstName: {
                value: null,
                hasError: false,
                errorMessage: null
            },
            lastName: {
                value: null,
                hasError: false,
                errorMessage: null
            },
            mobileNumber: {
                value: "27",
                hasError: false,
                errorMessage: null
            },
            loading: false
        };
    },
    methods: {
        validateForm() {
            this.saveCustomerDetails();
        },
        onMobileNumberInput(){
            console.log("length", this.mobileNumber.value.length)
            if(this.mobileNumber.value === null || this.mobileNumber.value === ""){
                this.mobileNumber.value = "27";
            }
            // else{
            //     this.mobileNumber.value = "27" + this.mobileNumber.value;
            // }
            else if(this.mobileNumber.value.length < 2){
                this.mobileNumber.value = "27";
            }
            else{
                this.mobileNumber.value = "27" + this.mobileNumber.value.substring(2);
            }
        },
        saveCustomerDetails() {
            this.loading = true;
            customerService.addCustomerLead(this.firstName.value, this.lastName.value, this.mobileNumber.value).then(response => {
                var obj = {
                    canContinue: true,
                    instanceId: null
                };
                if (response.status === 400) {
                    // show validation errors
                    this.firstName.hasError = response.data.customerSignUpStepOneValidationResponse.firstNameValidationResponse.hasError;
                    this.firstName.errorMessage = response.data.customerSignUpStepOneValidationResponse.firstNameValidationResponse.message;
                    
                    this.lastName.hasError = response.data.customerSignUpStepOneValidationResponse.lastNameValidationResponse.hasError;
                    this.lastName.errorMessage = response.data.customerSignUpStepOneValidationResponse.lastNameValidationResponse.message;
                    
                    this.mobileNumber.hasError = response.data.customerSignUpStepOneValidationResponse.mobileNumberValidationResponse.hasError;
                    this.mobileNumber.errorMessage = response.data.customerSignUpStepOneValidationResponse.mobileNumberValidationResponse.message;

                    if(response.data.validationResult !== null) {
                        if (response.data.validationResult.cellNumberDoesNotExist === false) {
                            this.mobileNumber.hasError = true;
                            this.mobileNumber.errorMessage = "This mobile number already exists";
                        }
                    }
                    
                    obj.canContinue = false;
                    this.$emit("canContinue", obj);
                } 
                if (response.status === 200) {
                    if (response.data == null) {
                        obj.canContinue = false;
                        // we didn't get any response, somethings wrong
                        this.$emit("canContinue", obj);
                    }

                    // successful response
                    obj.canContinue = true;
                    obj.instanceId = response.data.instanceId;
                    this.$emit("canContinue", obj);
                }
                this.loading = false;
            });
        }
    },
    mounted: function () {

    }
};